import Vue from 'vue'
import vueHtml from '@directives/vue-html.js'

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

Vue.directive('vue-html', vueHtml)
